import API from "@zillow/mortgage-api-client";
import { createMax } from "../../utils/mortgagehelpers/mortgage-helpers.esm.js";
import { DEFAULT_PARTNER_ID } from "../../utils/mortgagehelpers/constants.esm.js";
const fetchRatesArticle = async (input) => {
  const inputs = {
    partnerId: API.partnerId ? API.partnerId : DEFAULT_PARTNER_ID,
    ...input
  };
  createMax();
  if (input.stateAbbreviation === "US") {
    delete inputs.stateAbbreviation;
  }
  try {
    return await API.MAX.GET({
      action: "getRatesArticle",
      input: inputs
    });
  } catch (e) {
    console.error(e);
    return {
      content: "",
      hasApiError: true
    };
  }
};
export {
  fetchRatesArticle
};
